import { homepageBlocks } from './homepage';
import { tagBlocks } from './tag';
import { categoryBlocks } from './category';
import { articleBlocks } from './article';
import { webviewBlocks } from './webview';
import { customBlocks } from './custom';
export const adBlocks = {
  Homepage: homepageBlocks,
  Tag: tagBlocks,
  Category: categoryBlocks,
  Article: articleBlocks,
  Webview: webviewBlocks,
  Custom: customBlocks,
};
